<script setup>
import TournamentStageMatrix from "~/components/tournaments/TournamentStageMatrix.vue";
import FixtureResultRow from "~/components/fixtures/FixtureResultRow.vue";
import {computed, ref} from "vue";

// Timeline rendering for a tournament stage (Flutter BracketKnockoutStage):
// group stages reuse the standings matrix; knockout rounds list their fixtures
// using the SAME result-row cell as the fixtures list, so every fixture cell
// looks the same across the app.
const props = defineProps({
  stage: {
    type: Object,
    required: true
  }
})

const stageModel = ref(props.stage)
const isGroup = computed(() => props.stage?.type === 1)
const fixtures = computed(() => props.stage?.fixtures ?? [])
</script>

<template>
  <div class="tournament-stage-timeline-item">
    <tournament-stage-matrix
        v-if="isGroup && stage.teams"
        v-model="stageModel"
        :simple="true"
    />
    <template v-else>
      <fixture-result-row
          v-for="fixture in fixtures.slice(0, 4)"
          :key="fixture.id"
          :fixture="fixture"
      />
    </template>
  </div>
</template>
